import { useMutation } from '@tanstack/react-query';
import { exportProblems } from '../../../api/problems';

interface Parameters {
  organizationId?: string;
  systemId?: string;
  search?: string;
  status?: string;
  tags?: string[];
  order?: string;
  ordinance?: string;
}

const useExportProblems = (options?: {}) => {
  return useMutation({
    mutationFn: (parameters: Parameters) => exportProblems(parameters),
    ...options,
  });
};

export default useExportProblems;
